const BasePrice = ({basePrice, option}: IBasePriceProps) => {
  return (
    <>
      <div className=" mt-7 flex justify-between">
        <p className=" text-gray-6">قیمت پایه:</p>
        <p className=" text-gray-6">
          {basePrice} {option}
        </p>
      </div>
    </>
  );
};

export default BasePrice;
